import { types } from "../types/windTurbine";

const domainInitialState = {
  nzSetting: { value: "Manual", label: "Manual" },
  nz: 1000,
  stretchLevel: 500,
  StretchFactor: 1.08,
  dzMax: 1000,
  heightAuto: 1000,
};

const windProfilesInitialState = {
  windProfileSettingsMode: { value: "Manual", label: "Manual" },
  uComponentOfGeostrophicWind: 9,
  vComponentOfGeostrophicWind: 9,
  hubHeight: 100,
  windSpeedAtHubHeight: 0,
  windDirectionAtHubHeight: 0,
  temperatureProfile: { value: "Neutral", label: "Neutral" },
  substanceProfile: { value: "Profile1", label: "Profile1" },
};

const windTurbineInitialState = {
  rotorTable: { value: "Preset1", label: "Preset1" },
  rotorSpeed: 0.1,
  yawAngle: 0,
  rotorPlaneTiltAngle: 0,
  generatorRatedMechanicalPower: 5296610.0,
  activateSpeedControl: false,
  activatePitchControl: false,
  activateYawControl: false,
  yawActuatorSpeed: 0.005236,
  dragCoefficientTower: 1.2,
  tangentialLengthOfRotorSegments: 1,
  radialWidthOfRotorSegments: 0.5,
  numberOfAirfoils: 8,
};

const parametersInitialState = {
  roughnessLengthDomain: 0.1,
  surfaceHeatflux: 1,
  rayleighDampingHeight: 500,
  rayleighDampeningFactor: 0.5,
  intertialOscillationDampeningFactor: 0.9,
  canopyDragCoefficient: 0.15,
  wallHeatfluxTopSurface: 1,
};

const runtimeInitialState = {
  coresInXDirection: 10,
  coresInYDirection: 10,
  simulationDuration: 10800,
};

const dataOutputInitialState = {
  netcdfDataFormat: { value: "3", label: "3" },
  skipTimeBeforeDataOutput: 0,
  timeIntervalRunControlOutput: 60,
  timeIntervalDataOutput: 0,
  timeIntervalAverageDataOutput: 0,
  timeIntervalTimeseriesOutput: 0,
  timeIntervalProfilesOutput: 0,
  timeInterval3DOutput: 0,
  averagingInterval: 0,
  timePeriodForAveraging: 0,
  averagingIntervalForProfiles: 0,
  timePeriodForProfilesAveraging: 0,
  section_yz: [],
  section_xz: [],
  mask_k_over_surface: 20,
};

const initialState = {
  windTurbineMode: { value: "Precursor", label: "Precursor" },
  precursorCase: null,
  ...domainInitialState,
  ...windProfilesInitialState,
  ...windTurbineInitialState,
  ...parametersInitialState,
  ...runtimeInitialState,
  ...dataOutputInitialState,
  // POI and Wind Turbine Data Management
  poiOptions: [],
  selectedPoi: [],
  windTurbineOptions: [],
  selectedWindTurbine: [],
  dataLoaded: false,
  precursorCaseOptions: [],
};

const windTurbineReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_WIND_TURBINE_MODE:
      return {
        ...state,
        windTurbineMode: action.payload,
      };
    case types.SET_PRECURSOR_CASE:
      return {
        ...state,
        precursorCase: action.payload,
      };

    case types.SET_NZ_SETTING:
      return {
        ...state,
        nzSetting: action.payload,
      };

    case types.SET_NZ:
      return {
        ...state,
        nz: action.payload,
      };

    case types.SET_STRETCH_LEVEL:
      return {
        ...state,
        stretchLevel: action.payload,
      };

    case types.SET_STRETCH_FACTOR:
      return {
        ...state,
        StretchFactor: action.payload,
      };

    case types.SET_DZ_MAX:
      return {
        ...state,
        dzMax: action.payload,
      };

    case types.SET_HEIGHT_AUTO:
      return {
        ...state,
        heightAuto: action.payload,
      };

    case types.SET_WIND_PROFILE_SETTINGS_MODE:
      return {
        ...state,
        windProfileSettingsMode: action.payload,
      };

    case types.SET_U_COMPONENT_OF_GEOSTROPHIC_WIND:
      return {
        ...state,
        uComponentOfGeostrophicWind: action.payload,
      };

    case types.SET_V_COMPONENT_OF_GEOSTROPHIC_WIND:
      return {
        ...state,
        vComponentOfGeostrophicWind: action.payload,
      };

    case types.SET_HUB_HEIGHT:
      return {
        ...state,
        hubHeight: action.payload,
      };

    case types.SET_WIND_SPEED_AT_HUB_HEIGHT:
      return {
        ...state,
        windSpeedAtHubHeight: action.payload,
      };

    case types.SET_WIND_DIRECTION_AT_HUB_HEIGHT:
      return {
        ...state,
        windDirectionAtHubHeight: action.payload,
      };

    case types.SET_TEMPERATURE_PROFILE:
      return {
        ...state,
        temperatureProfile: action.payload,
      };

    case types.SET_SUBSTANCE_PROFILE:
      return {
        ...state,
        substanceProfile: action.payload,
      };

    case types.SET_ROTOR_TABLE:
      return {
        ...state,
        rotorTable: action.payload,
      };

    case types.SET_ROTOR_SPEED:
      return {
        ...state,
        rotorSpeed: action.payload,
      };

    case types.SET_YAW_ANGLE:
      return {
        ...state,
        yawAngle: action.payload,
      };

    case types.SET_ROTOR_PLANE_TILT_ANGLE:
      return {
        ...state,
        rotorPlaneTiltAngle: action.payload,
      };

    case types.SET_GENERATOR_RATED_MECHANICAL_POWER:
      return {
        ...state,
        generatorRatedMechanicalPower: action.payload,
      };

    case types.SET_ACTIVATE_SPEED_CONTROL:
      return {
        ...state,
        activateSpeedControl: action.payload,
      };

    case types.SET_ACTIVATE_PITCH_CONTROL:
      return {
        ...state,
        activatePitchControl: action.payload,
      };

    case types.SET_ACTIVATE_YAW_CONTROL:
      return {
        ...state,
        activateYawControl: action.payload,
      };

    case types.SET_YAW_ACTUATOR_SPEED:
      return {
        ...state,
        yawActuatorSpeed: action.payload,
      };

    case types.SET_DRAG_COEFFICIENT_TOWER:
      return {
        ...state,
        dragCoefficientTower: action.payload,
      };

    case types.SET_TANGENTIAL_LENGTH_OF_ROTOR_SEGMENTS:
      return {
        ...state,
        tangentialLengthOfRotorSegments: action.payload,
      };

    case types.SET_RADIAL_WIDTH_OF_ROTOR_SEGMENTS:
      return {
        ...state,
        radialWidthOfRotorSegments: action.payload,
      };

    case types.SET_NUMBER_OF_AIRFOILS:
      return {
        ...state,
        numberOfAirfoils: action.payload,
      };

    case types.SET_ROUGHNESS_LENGTH_DOMAIN:
      return {
        ...state,
        roughnessLengthDomain: action.payload,
      };

    case types.SET_SURFACE_HEATFLUX:
      return {
        ...state,
        surfaceHeatflux: action.payload,
      };

    case types.SET_RAYLEIGH_DAMPING_HEIGHT:
      return {
        ...state,
        rayleighDampingHeight: action.payload,
      };

    case types.SET_RAYLEIGH_DAMPENING_FACTOR:
      return {
        ...state,
        rayleighDampeningFactor: action.payload,
      };

    case types.SET_INTERTIAL_OSCILLATION_DAMPENING_FACTOR:
      return {
        ...state,
        intertialOscillationDampeningFactor: action.payload,
      };

    case types.SET_CANOPY_DRAG_COEFFICIENT:
      return {
        ...state,
        canopyDragCoefficient: action.payload,
      };

    case types.SET_WALL_HEATFLUX_TOP_SURFACE:
      return {
        ...state,
        wallHeatfluxTopSurface: action.payload,
      };

    case types.SET_CORES_IN_X_DIRECTION:
      return {
        ...state,
        coresInXDirection: action.payload,
      };

    case types.SET_CORES_IN_Y_DIRECTION:
      return {
        ...state,
        coresInYDirection: action.payload,
      };

    case types.SET_SIMULATION_DURATION:
      return {
        ...state,
        simulationDuration: action.payload,
      };

    case types.SET_NETCDF_DATA_FORMAT:
      return {
        ...state,
        netcdfDataFormat: action.payload,
      };

    case types.SET_SKIP_TIME_BEFORE_DATA_OUTPUT:
      return {
        ...state,
        skipTimeBeforeDataOutput: action.payload,
      };

    case types.SET_TIME_INTERVAL_RUN_CONTROL_OUTPUT:
      return {
        ...state,
        timeIntervalRunControlOutput: action.payload,
      };

    case types.SET_TIME_INTERVAL_DATA_OUTPUT:
      return {
        ...state,
        timeIntervalDataOutput: action.payload,
      };

    case types.SET_TIME_INTERVAL_AVERAGE_DATA_OUTPUT:
      return {
        ...state,
        timeIntervalAverageDataOutput: action.payload,
      };

    case types.SET_TIME_INTERVAL_TIMESERIES_OUTPUT:
      return {
        ...state,
        timeIntervalTimeseriesOutput: action.payload,
      };

    case types.SET_TIME_INTERVAL_PROFILES_OUTPUT:
      return {
        ...state,
        timeIntervalProfilesOutput: action.payload,
      };

    case types.SET_TIME_INTERVAL_3D_OUTPUT:
      return {
        ...state,
        timeInterval3DOutput: action.payload,
      };

    case types.SET_AVERAGING_INTERVAL:
      return {
        ...state,
        averagingInterval: action.payload,
      };

    case types.SET_TIME_PERIOD_FOR_AVERAGING:
      return {
        ...state,
        timePeriodForAveraging: action.payload,
      };

    case types.SET_AVERAGING_INTERVAL_FOR_PROFILES:
      return {
        ...state,
        averagingIntervalForProfiles: action.payload,
      };

    case types.SET_TIME_PERIOD_FOR_PROFILES_AVERAGING:
      return {
        ...state,
        timePeriodForProfilesAveraging: action.payload,
      };

    case types.LOAD_WIND_TURBINE_SETTINGS:
      // This would be populated when loading settings from API
      return {
        ...state,
        ...action.payload,
      };

    case types.LOAD_SAVED_WIND_TURBINE_SETTINGS:
      const {
        initialization_parameters,
        runtime_parameters,
        wind_turbine_parameters,
      } = action.payload;
      let newState = { ...state };

      if (initialization_parameters) {
        if (initialization_parameters.mode) {
          newState.windTurbineMode = {
            value: initialization_parameters.mode,
            label: initialization_parameters.mode,
          };
        }
        if (
          initialization_parameters.precursor_case &&
          initialization_parameters.precursor_case.value &&
          initialization_parameters.precursor_case.label
        ) {
          newState.precursorCase = {
            value: initialization_parameters.precursor_case.value,
            label: initialization_parameters.precursor_case.label,
          };
        }
        if (initialization_parameters.nz_setting) {
          newState.nzSetting = {
            value: initialization_parameters.nz_setting,
            label: initialization_parameters.nz_setting,
          };
        }
        if (initialization_parameters.nz) {
          newState.nz = initialization_parameters.nz;
        }
        if (initialization_parameters.dz_stretch_level) {
          newState.stretchLevel = initialization_parameters.dz_stretch_level;
        }
        if (initialization_parameters.dz_stretch_level_factor) {
          newState.StretchFactor =
            initialization_parameters.dz_stretch_level_factor;
        }
        if (initialization_parameters.dz_max) {
          newState.dzMax = initialization_parameters.dz_max;
        }
        if (initialization_parameters.height_auto) {
          newState.heightAuto = initialization_parameters.height_auto;
        }
      }

      if (runtime_parameters) {
        if (runtime_parameters.npex) {
          newState.coresInXDirection = runtime_parameters.npex;
        }
        if (runtime_parameters.npey) {
          newState.coresInYDirection = runtime_parameters.npey;
        }
        if (runtime_parameters.end_time) {
          newState.simulationDuration = runtime_parameters.end_time;
        }
        if (runtime_parameters.netcdf_data_format) {
          newState.netcdfDataFormat = {
            value: runtime_parameters.netcdf_data_format,
            label: runtime_parameters.netcdf_data_format,
          };
        }
        if (runtime_parameters.skip_time_data_output) {
          newState.skipTimeBeforeDataOutput =
            runtime_parameters.skip_time_data_output;
        }
        if (runtime_parameters.dt_run_control) {
          newState.timeIntervalRunControlOutput =
            runtime_parameters.dt_run_control;
        }
        if (runtime_parameters.dt_data_output) {
          newState.timeIntervalDataOutput = runtime_parameters.dt_data_output;
        }
        if (runtime_parameters.dt_data_output_av) {
          newState.timeIntervalAverageDataOutput =
            runtime_parameters.dt_data_output_av;
        }
        if (runtime_parameters.dt_dots) {
          newState.timeIntervalTimeseriesOutput = runtime_parameters.dt_dots;
        }
        if (runtime_parameters.dt_dopr) {
          newState.timeIntervalProfilesOutput = runtime_parameters.dt_dopr;
        }
        if (runtime_parameters.dt_do3d) {
          newState.timeInterval3DOutput = runtime_parameters.dt_do3d;
        }
        if (runtime_parameters.section_yz) {
          newState.section_yz = Array.isArray(runtime_parameters.section_yz)
            ? runtime_parameters.section_yz
            : [
                {
                  value: runtime_parameters.section_yz,
                  label: runtime_parameters.section_yz,
                },
              ];
        }
        if (runtime_parameters.section_xz) {
          newState.section_xz = Array.isArray(runtime_parameters.section_xz)
            ? runtime_parameters.section_xz
            : [
                {
                  value: runtime_parameters.section_xz,
                  label: runtime_parameters.section_xz,
                },
              ];
        }
        if (runtime_parameters.mask_k_over_surface) {
          newState.mask_k_over_surface = runtime_parameters.mask_k_over_surface;
        }
        if (runtime_parameters.averaging_interval) {
          newState.averagingInterval = runtime_parameters.averaging_interval;
        }
        if (runtime_parameters.dt_averaging_input) {
          newState.timePeriodForAveraging =
            runtime_parameters.dt_averaging_input;
        }
        if (runtime_parameters.averaging_interval_pr) {
          newState.averagingIntervalForProfiles =
            runtime_parameters.averaging_interval_pr;
        }
        if (runtime_parameters.dt_averaging_input_pr) {
          newState.timePeriodForProfilesAveraging =
            runtime_parameters.dt_averaging_input_pr;
        }
      }
      if (wind_turbine_parameters) {
        if (wind_turbine_parameters.mode) {
          newState.windTurbineMode = {
            value: wind_turbine_parameters.mode,
            label: wind_turbine_parameters.mode,
          };
        }
        if (
          wind_turbine_parameters.precursor_case &&
          wind_turbine_parameters.precursor_case.value &&
          wind_turbine_parameters.precursor_case.label
        ) {
          newState.precursorCase = {
            value: wind_turbine_parameters.precursor_case.value,
            label: wind_turbine_parameters.precursor_case.label,
          };
        }
        if (wind_turbine_parameters.wind_profile_settings_mode) {
          newState.windProfileSettingsMode = {
            value: wind_turbine_parameters.wind_profile_settings_mode,
            label: wind_turbine_parameters.wind_profile_settings_mode,
          };
        }
        if (wind_turbine_parameters.ug) {
          newState.uComponentOfGeostrophicWind = wind_turbine_parameters.ug;
        }
        if (wind_turbine_parameters.vg) {
          newState.vComponentOfGeostrophicWind = wind_turbine_parameters.vg;
        }
        if (wind_turbine_parameters.hub_height) {
          newState.hubHeight = wind_turbine_parameters.hub_height;
        }
        if (wind_turbine_parameters.wind_speed_hh) {
          newState.windSpeedAtHubHeight = wind_turbine_parameters.wind_speed_hh;
        }
        if (wind_turbine_parameters.wind_dir_hh) {
          newState.windDirectionAtHubHeight =
            wind_turbine_parameters.wind_dir_hh;
        }
        if (wind_turbine_parameters.profile_temperature) {
          newState.temperatureProfile = {
            value: wind_turbine_parameters.profile_temperature,
            label: wind_turbine_parameters.profile_temperature,
          };
        }
        if (wind_turbine_parameters.profile_subsidance) {
          newState.substanceProfile = {
            value: wind_turbine_parameters.profile_subsidance,
            label: wind_turbine_parameters.profile_subsidance,
          };
        }
        if (wind_turbine_parameters.rotor_table) {
          newState.rotorTable = {
            value: wind_turbine_parameters.rotor_table,
            label: wind_turbine_parameters.rotor_table,
          };
        }
        if (wind_turbine_parameters.rotor_speed) {
          newState.rotorSpeed = wind_turbine_parameters.rotor_speed;
        }
        if (wind_turbine_parameters.yaw_angle) {
          newState.yawAngle = wind_turbine_parameters.yaw_angle;
        }
        if (wind_turbine_parameters.tilt_angle) {
          newState.rotorPlaneTiltAngle = wind_turbine_parameters.tilt_angle;
        }
        if (wind_turbine_parameters.generator_power_rated) {
          newState.generatorRatedMechanicalPower =
            wind_turbine_parameters.generator_power_rated;
        }
        if (wind_turbine_parameters.speed_control) {
          newState.activateSpeedControl = wind_turbine_parameters.speed_control;
        }
        if (wind_turbine_parameters.pitch_control) {
          newState.activatePitchControl = wind_turbine_parameters.pitch_control;
        }
        if (wind_turbine_parameters.yaw_control) {
          newState.activateYawControl = wind_turbine_parameters.yaw_control;
        }
        if (wind_turbine_parameters.yaw_speed) {
          newState.yawActuatorSpeed = wind_turbine_parameters.yaw_speed;
        }
        if (wind_turbine_parameters.tower_cd) {
          newState.dragCoefficientTower = wind_turbine_parameters.tower_cd;
        }
        if (wind_turbine_parameters.segment_length_tangential) {
          newState.tangentialLengthOfRotorSegments =
            wind_turbine_parameters.segment_length_tangential;
        }
        if (wind_turbine_parameters.segment_width_radial) {
          newState.radialWidthOfRotorSegments =
            wind_turbine_parameters.segment_width_radial;
        }
        if (wind_turbine_parameters.n_airfoils) {
          newState.numberOfAirfoils = wind_turbine_parameters.n_airfoils;
        }
        if (wind_turbine_parameters.roughness_length) {
          newState.roughnessLengthDomain =
            wind_turbine_parameters.roughness_length;
        }
        if (wind_turbine_parameters.surface_heatflux) {
          newState.surfaceHeatflux = wind_turbine_parameters.surface_heatflux;
        }
        if (wind_turbine_parameters.rayleigh_damping_height) {
          newState.rayleighDampingHeight =
            wind_turbine_parameters.rayleigh_damping_height;
        }
        if (wind_turbine_parameters.rayleigh_dampening_factor) {
          newState.rayleighDampeningFactor =
            wind_turbine_parameters.rayleigh_dampening_factor;
        }
        if (wind_turbine_parameters.inertial_oscillation_damping_factor) {
          newState.intertialOscillationDampeningFactor =
            wind_turbine_parameters.inertial_oscillation_damping_factor;
        }
        if (wind_turbine_parameters.canopy_drag_coeff) {
          newState.canopyDragCoefficient =
            wind_turbine_parameters.canopy_drag_coeff;
        }
        if (wind_turbine_parameters.wall_heatflux_top_surface) {
          newState.wallHeatfluxTopSurface =
            wind_turbine_parameters.wall_heatflux_top_surface;
        }
      }

      return newState;

    case types.RESET_WIND_TURBINE_SETTINGS:
      return {
        ...initialState,
      };

    case types.SET_SECTION_YZ:
      return {
        ...state,
        section_yz: action.payload || [],
      };

    case types.SET_SECTION_XZ:
      return {
        ...state,
        section_xz: action.payload || [],
      };

    case types.SET_MASK_OVER_SURFACE:
      return {
        ...state,
        mask_k_over_surface: action.payload,
      };

    case types.SET_WIND_TURBINE_POI_OPTIONS:
      return {
        ...state,
        poiOptions: action.payload,
      };

    case types.SET_WIND_TURBINE_POI_SELECTED:
      return {
        ...state,
        selectedPoi: action.payload,
      };

    case types.SET_WIND_TURBINE_WIND_TURBINE_OPTIONS:
      return {
        ...state,
        windTurbineOptions: action.payload,
      };

    case types.SET_WIND_TURBINE_WIND_TURBINE_SELECTED:
      return {
        ...state,
        selectedWindTurbine: action.payload,
      };

    case types.SET_WIND_TURBINE_DATA_LOADED:
      return {
        ...state,
        dataLoaded: action.payload,
      };

    case types.SET_PRECURSOR_CASE_OPTIONS:
      return {
        ...state,
        precursorCaseOptions: action.payload,
      };

    default:
      return state;
  }
};

export default windTurbineReducer;
